import moment from "moment"

const initialState = {
  invoiceProducts: [],
  senderAddress: "184, Buthgamuwa Road",
  senderCity: "Rajagiriya, Sri Lanka",
  senderTel: "0112 805 005 / 0761 399 060 / 0761 399 063",
  date: moment().format("YYYY-MM-DD"),
  invoiceNumber: "",
  paymentMethod: "",
  chequeDetails: "",
  bankName: "",
  salesManager: "",
  paymentTerms: "On Delivery",
  collectionMethod: "",
  dueDate: moment().format("YYYY-MM-DD"),
  deliverTo: "",
  customerCode: "",
  customer: {},
  cancelled: false,
  transport: "",
  invoiceType: "",
  oldSN: "",
  oldInvoiceNum: "",
  modelType: "",
  troubleshootingRef: "",
  rrnRef: "",
  serviceCharge: "",
  quotationNumber: "",
  isDraft: false,
}

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case `SAVE_INVOICE`:
      return {
        ...state,
        invoiceNumber: action.data,
      }
    case `SET_INVOICE_PRODUCTS`:
      return {
        ...state,
        invoiceProducts: action.data,
      }
    case `ADD_PRODUCT`:
      return {
        ...state,
        invoiceProducts: action.data,
      }
    case `DELETE_PRODUCT`:
      return {
        ...state,
        invoiceProducts: action.data,
      }
    case `SET_DATE`:
      return {
        ...state,
        date: action.data,
      }
    case `SET_INVOICE_NUMBER`:
      return {
        ...state,
        invoiceNumber: action.data,
      }
    case `SET_PAYMENT_METHOD`:
      return {
        ...state,
        paymentMethod: action.data,
      }
    case `SET_CHEQUE_DETAILS`:
      return {
        ...state,
        chequeDetails: action.data,
      }
    case `SET_BANK_NAME`:
      return {
        ...state,
        bankName: action.data,
      }
    case `SET_TRANSPORT`:
      return {
        ...state,
        transport: action.data,
      }
    case `SET_SALES_MANAGER`:
      return {
        ...state,
        salesManager: action.data,
      }
    case `SET_PAYMENT_TERMS`:
      return {
        ...state,
        paymentTerms: action.data,
      }
    case `SET_COLLECTION_METHOD`:
      return {
        ...state,
        collectionMethod: action.data,
      }
    case `SET_DUE_DATE`:
      return {
        ...state,
        dueDate: action.data,
      }
    case `SET_DELIVER_TO`:
      return {
        ...state,
        deliverTo: action.data,
      }
    case `SET_CUSTOMER_CODE`:
      return {
        ...state,
        customerCode: action.data,
      }

    case `SET_INVOICE_TYPE`:
      return {
        ...state,
        invoiceType: action.data,
      }
    case `SET_OLD_SN`:
      return {
        ...state,
        oldSN: action.data,
      }
    case `SET_OLD_INVOICE_NUM`:
      return {
        ...state,
        oldInvoiceNum: action.data,
      }
    case `SET_INVOICE_MODEL_TYPE`:
      return {
        ...state,
        modelType: action.data,
      }
    case `SET_INVOICE_TROUBLESHOOTING_REF`:
      return {
        ...state,
        troubleshootingRef: action.data,
      }

    case `SET_INVOICE_RRN_REF`:
      return {
        ...state,
        rrnRef: action.data,
      }
    case `SET_INVOICE_SERVICE_CHARGE`:
      return {
        ...state,
        serviceCharge: action.data,
      }

    case `SET_CUSTOMER`:
      return {
        ...state,
        customer: action.data,
      }
    case `SET_INVOICE_QUOTATION_NUMBER`:
      return {
        ...state,
        quotationNumber: action.data,
      }
    case `SET_IS_DRAFT`:
      return {
        ...state,
        isDraft: action.data,
      }
    case `CLEAR_INVOICE`:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default invoiceReducer
